import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Main from "../../components/Main";
import TabelaDinamica from "../../components/TabelaDinamica";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import styles from "./styles.module.css";
import DomainIcon from "@mui/icons-material/Domain";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  Switch,
  Button,
  Input,
  Paper,
  DialogContentText,
} from "@mui/material";

import Draggable from "react-draggable";

import PropTypes from "prop-types";

import SearchIcon from "@mui/icons-material/Search";
import CRUDPageHeader from "../../components/CRUDPageHeader";
import {
  buscarTodosGruposEconomicos,
  buscarGruposPorTexto,
  cadastraGrupoEconomico,
  atualizarGrupoEconomico,
  deletarGrupoEconomico,
} from "../../services/api-empresas.service";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const GruposEconomicos = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [editRowData, setEditRowData] = useState({});
  const [loading, setLoading] = useState(false);

  const handleOpenModal = (rowData) => {
    setEditRowData(rowData);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSaveChanges = async () => {
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    };

    const body = {
      grupoEconomico: {
        nome: editRowData.nome,
        schema: editRowData.schema,
        ativo: editRowData.ativo,
      },
    };

    setLoading(true);

    if (!editRowData.idGrupoEconomico) {
      // Cadastra
      try {
        const responseCadastra = await cadastraGrupoEconomico(body, headers);
        setMsg(responseCadastra.mensagem);

        const responseBusca = await buscarTodosGruposEconomicos();
        setData(responseBusca.gruposEconomicos);

      } catch (err) {
        if (err.responseCadastra) {
          setMsg(err.responseCadastra.mensagem);
          handleOpenSnackbarErro();
        } else {
          setMsg("Erro: Tente novamente!");
          handleOpenSnackbarErro();
        }
      }
    } else {
      // Altera
      try {
        const responseUpdate = await atualizarGrupoEconomico(
          editRowData.idGrupoEconomico,
          body,
          headers
        );
        setMsg(responseUpdate.mensagem);

        const responseBusca = await buscarTodosGruposEconomicos();
        setData(responseBusca.gruposEconomicos);

      } catch (err) {
        if (err.response) {
          setMsg(err.response.mensagem);
          handleOpenSnackbarErro();
        } else {
          setMsg("Erro: Tente novamente!");
          handleOpenSnackbarErro();
        }
      }
    }

    setLoading(false);
    handleCloseModal();
    handleOpenSnackbarSucesso();
  };

  const handleDelete = async () => {
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    };

    setLoading(true);

    //Deleta
    try {
      const responseDelete = await deletarGrupoEconomico(
        editRowData.idGrupoEconomico,
        headers
      );
      setMsg(responseDelete.mensagem);

      const responseBusca = await buscarTodosGruposEconomicos();
      setData(responseBusca.gruposEconomicos);
      
    } catch (err) {
      if (err.response) {
        setMsg(err.response.mensagem);
        handleOpenSnackbarErro();
      } else {
        setMsg("Erro: Tente novamente!");
        handleOpenSnackbarErro();
      }
    }

    setLoading(false);
    handleCloseDialogExclusao();
    handleOpenSnackbarSucesso();
  };

  const columns = [
    { id: "idGrupoEconomico", label: "ID", field: "idGrupoEconomico" },
    { id: "nome", label: "Nome", field: "nome" },
    { id: "ativo", label: "Ativo", field: "ativo" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await buscarTodosGruposEconomicos();

        setData(response.gruposEconomicos);
      } catch (err) {
        if (err.response) {
          setMsg(err.response.mensagem);
          handleOpenSnackbarErro();
        } else {
          setMsg("Erro: Tente novamente!");
          handleOpenSnackbarErro();
        }
      }
      setLoading(false);
    };

    fetchData();
  }, [navigate]);

  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);
  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarSucesso(true);
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const [msg, setMsg] = useState("");

  const [openDialogExclusao, setOpenDialogExclusao] = React.useState(false);

  const handleClickOpenDialogExclusao = (rowData) => {
    setEditRowData(rowData);
    setOpenDialogExclusao(true);
  };

  const handleCloseDialogExclusao = () => {
    setOpenDialogExclusao(false);
  };

  const handleDebouncerChange = async (event) => {
    setLoading(true);
    try {
      const response = await buscarGruposPorTexto(event.target.value);
      setData(response.grupoEconomico);
    } catch (err) {
      if (err.response && err.response.status === 404) {
        setData([]);
      } else {
        setMsg(err.response);
        setOpenSnackbarErro(true);
      }
    }
    setLoading(false);
  };

  return (
    <div>
      <Main />
      <CRUDPageHeader
        headerIcon={
          <DomainIcon fontSize="30px" sx={{ marginBottom: "10px"}}/>
        }
        headerTitle={"Grupos Econômicos"}
        handleDebounceChange={handleDebouncerChange}
        handleOpenModal={handleOpenModal}
        modalButtonLabel={"Novo"}
      />

      <div className={styles.linhaTitulo} />

      <TabelaDinamica
        data={data}
        columns={columns}
        loading={loading}
        onEditButtonClick={handleOpenModal}
        onDeleteButtonClick={handleClickOpenDialogExclusao}
      />
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        PaperProps={{
          style: {
            width: "740px", // Defina a largura desejada
            height: "100vh",
          },
        }}
        maxWidth="md" // Defina o tamanho máximo do modal
      >
        <DialogTitle>
          <div className={styles.tituloPopupContainer}>
            <DomainIcon />
            <h1 className={styles.tituloPopup}>Grupo Econômico</h1>
          </div>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <label>ID</label>
              <TextField
                value={
                  editRowData.idGrupoEconomico
                    ? editRowData.idGrupoEconomico
                    : "Novo registro"
                }
                variant="outlined"
                fullWidth
                size="small"
                disabled
              />
            </Grid>

            <Grid item xs={6}></Grid>

            <Grid item xs={8}>
              <label>Nome</label>
              <TextField
                value={editRowData.nome}
                onChange={(e) =>
                  setEditRowData({ ...editRowData, nome: e.target.value })
                }
                variant="outlined"
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={4}></Grid>
            <Grid item xs={6}>
              <label>Ativo</label>
              <Switch
                checked={editRowData.ativo}
                onChange={(e) =>
                  setEditRowData({
                    ...editRowData,
                    ativo: e.target.checked,
                  })
                }
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className={styles.botoesPopupGeral}>
          <Button
            className={styles.botaoPopupCancelar}
            onClick={handleCloseModal}
            size="small"
          >
            Cancelar
          </Button>
          <Button
            className={styles.botaoPopupSalvar}
            onClick={handleSaveChanges}
            color="primary"
            size="small"
          >
            Salvar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog de exclusão */}
      <Dialog
        open={openDialogExclusao}
        onClose={handleCloseDialogExclusao}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          className={styles.tituloExclusao}
          style={{ cursor: "move" }}
          id="draggable-dialog-title"
        >
          Atenção!
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={styles.textoExclusao}>
            Você realmente deseja excluir permanentemente o grupo econômico
            selecionado?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className={styles.botaoPopupCancelarExclusao}
            autoFocus
            onClick={handleCloseDialogExclusao}
          >
            Cancelar
          </Button>
          <Button className={styles.botaoPopupExcluir} onClick={handleDelete}>
            Sim
          </Button>
        </DialogActions>
      </Dialog>

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};

export default GruposEconomicos;
